import { render } from "./VideoTile.vue?vue&type=template&id=548f4f57&scoped=true"
import script from "./VideoTile.vue?vue&type=script&lang=js"
export * from "./VideoTile.vue?vue&type=script&lang=js"

import "./VideoTile.vue?vue&type=style&index=0&id=548f4f57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548f4f57"]])

export default __exports__